window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
//mimeType - string - the mime type we expect - application/json by default
//type - string - GET/POST/PUT/DELETE - GET by default
//data - object - the data we want to send on the request
//encoding - string -the encoding for the request - default UTF-8
//XMLHTTPOverride - boolean - for DELETE/PUT requests, this defines if we should add the X-HTTP-Method-Override header, default true
//cache - boolean - default false, if set to true request will appear identical and the browser will cache them sparing requests
//url - string - the url we will be using
//asynch - boolean - if the call should be asynch or not - default asynch
//headers - object - additional headers we want to add to the request
/**
 *  The object to send FETCH requests to the same domain
 */

lpTag.taglets.fetch = lpTag.taglets.fetch || (function lpFetch(window) {

        var contentTypes = {
                JSON: "application/json",
                JAVASCRIPT: "text/javascript",
                HTML: "text/html",
                XMLAPP: "application/xml",
                XMLTEXT: "text/xml",
                FORM: "application/x-www-form-urlencoded;"
            },//Mime types that are acceptable should be overrriden when known in advance and set as a header with encoding when sending
            requestTypes = {
                GET: "GET",
                POST: "POST",
                PUT: "PUT",
                PATCH: "PATCH",
                DELETE: "DELETE"
            },
            logTypes = {ERROR: "ERROR", DEBUG: "DEBUG", INFO: "INFO"},
            defaults = {
                encoding: "UTF-8",
                method: requestTypes.GET,
                asynch: true,
                timeout: 30000,
                mimeType: contentTypes.JSON,
                acceptHeader: "*/*",
                XMLHTTPOverride: true,
                retries: 2,
                metricsCount: 100,
                metricsTimeout: 60000,
                credentials: 'include',
                accessHeader: 'Authorization'
            },
            transportType = "fetch",
            version = "1.0.0",
            subDomain = _getSubDomain(document.location.href),
            XHTTPOverRideHeader = "X-HTTP-Method-Override",
            badRequestObj = {
                responseCode: 404,
                HTTPStatus: "bad request",
                body: {error: "Request timed out"},
                headers: ""
            },
            invalidRequest = {
                responseCode: 600,
                HTTPStatus: "unable to service request",
                body: {error: "Transport - " + transportType + " - unable to run request"},
                headers: ""
            },
            maxURLLength = 2083,
            callCount = 0,
            errorCount = 0,
            metricsTOId,
            buffer = [],
            pendingRequests = [],
            errorTimeoutId,
            requestStats = [],
            initialised = true,
            taglets = lpTag.taglets,
            lpAjax;


        /**
         * Where it all starts
         */

        function init() {
            if (taglets.lpAjax && taglets.lpAjax.addTransport) {
                lpAjax = taglets.lpAjax;
                try {
                    lpAjax.addTransport(transportType, publicAPI);
                } catch (exc) {
                }
            }
            _setMetricsTimeout();
        }

        /**
         * Set new defaults for request
         * that this layer makes
         */
        function configure(configuration) {
            if (configuration && configuration.defaults) {
                for (var key in configuration.defaults) {
                    if (configuration.defaults.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
                        defaults[key] = configuration.defaults[key];
                    }
                }
            }
            init();
            initialised = true;
        }

        /**
         * Validates this transport can handle the request
         * Conditions are same domain and get request smaller than
         * URL length maximum (also sets request defaults for the check)
         * @param reqObj
         * @return {Boolean}
         */
        function isValidRequest(reqObj) {
            reqObj = _setRequestDefaults(reqObj);
            var validRequest = reqObj && reqObj.url && typeof reqObj.url === 'string' && reqObj.url.length <= maxURLLength;
            return (initialised && validRequest);
        }


        /**
         * Makes or buffers a call depending on
         * the state of the transport
         * @param reqObj
         */
        function issueCall(reqObj) {
            return isValidRequest(reqObj) ? _addToBuffer(reqObj) : _runCallback(reqObj.error, invalidRequest, reqObj.context);
        }

        /**
         * Returns the configuration for the transport
         * @returns {{name: string, version: string, callsMade: number, errorsFound: number, pending: (Array.length|*), defaults}}
         */
        function inspect() {
            return {
                name: transportType,
                version: version,
                callsMade: callCount,
                errorsFound: errorCount,
                pending: pendingRequests.length,
                defaults: JSON.parse(_stringify(defaults))
            };
        }

        /**
         * Sets the request defaults according to what was
         * specified for the layer
         * @param reqObj
         * @return {*}
         */
        function _setRequestDefaults(reqObj) {
            if (subDomain !== _getSubDomain(reqObj.url)){
              reqObj = _addCorsHeaders(reqObj);
            }
            reqObj.method = reqObj.method || defaults.method;
            reqObj.credentials = defaults.credentials;
            reqObj.encoding = reqObj.encoding || defaults.encoding;
            reqObj.mimeType = reqObj.mimeType || defaults.mimeType;
            reqObj.retries = !isNaN(reqObj.retries) ? reqObj.retries : defaults.retries;
            reqObj.timeout = !isNaN(reqObj.timeout) ? reqObj.timeout : defaults.timeout;
            reqObj.XMLHTTPOverride = typeof reqObj.XMLHTTPOverride == 'boolean' ? reqObj.XMLHTTPOverride : defaults.XMLHTTPOverride;
            reqObj.asynch = typeof reqObj.asynch === 'boolean' ? reqObj.asynch : defaults.asynch;
            //Default override for PUT/Delete unless explicitly requested to ignore
            if ((reqObj.method.toLowerCase() === requestTypes.PUT.toLocaleLowerCase() ||
                reqObj.method.toLowerCase() === requestTypes.DELETE.toLocaleLowerCase()) &&
                reqObj.XMLHTTPOverride) {
                reqObj.headers[XHTTPOverRideHeader] = reqObj.method;
                reqObj.method = requestTypes.POST;
            }
            return reqObj;
        }

        function _addCorsHeaders(reqObj) {
            if (!reqObj.headers) {
              reqObj.headers = {};
            }
            reqObj.headers['Access-Control-Request-Method'] = reqObj.method;
            reqObj.headers['Access-Control-Request-Headers'] = reqObj.headers['Access-Control-Request-Headers'] || defaults.accessHeader;
            reqObj.headers.Origin = reqObj.headers.Origin || subDomain;
            return reqObj;
        }


        /**
         * Add a random number to the request to
         * make sure we don't get the cached browser
         * response back
         * @param reqObj
         */
        function _addCacheBuster(reqObj) {
            var indexOfRnd = reqObj.url.indexOf("__d=");
            if (indexOfRnd > -1) {
                reqObj.url = reqObj.url.substr(0, indexOfRnd - 1);
            }
            if (!reqObj.cache && (reqObj.method.toLowerCase() !== requestTypes.GET.toLowerCase() || reqObj.url.length <= (maxURLLength - 10))) {
                reqObj.url += reqObj.url.indexOf("?") > 0 ? "&__d=" : "?__d=";
                reqObj.url += Math.floor(Math.random() * 100000);
            }
        }

        /**
         * Function to extract the sub domain from any URL
         * @param url
         * @return {String}
         */
        function _getSubDomain(url) {
            var domainRegEx = new RegExp(/(http{1}s{0,1}?:\/\/)([^\/\?]+)(\/?)/ig);
            var matches, domain = null;
            if (url.indexOf("http") === 0) {
                matches = domainRegEx.exec(url);
            } else {
                matches = domainRegEx.exec(window.location.href);
            }
            if (matches && matches.length >= 3 && matches[2] !== "") {
                domain = matches[1].toLowerCase() + matches[2].toLowerCase(); // 0 - full match 1- HTTPS 2- domain
            }
            return domain;
        }


        function _send(reqObj) {
            if(reqObj.query){
              reqObj.url = _setUrlQuery(reqObj.url, reqObj.query);
              reqObj.query = null;
            }
            if(reqObj.method === requestTypes.GET && reqObj.data){
              reqObj.url = _setUrlQuery(reqObj.url, reqObj.data);
              reqObj.data = null;// Make sure we don't make the same changes in case of retry
            } else {//PUT/POST/DELETE requests can have a body
              if (typeof reqObj.data !== 'undefined') {
                reqObj.body = _stringifyData(reqObj.data);
              }
            }

            //Prevent caching request by adding random to URL
            _addCacheBuster(reqObj);
            _addToPendingRequests(reqObj);
            // _parse response will parse and call applicative success or error according to the server response
            // while catch in _send context is intended to catch the typeError that fetch will throw exclusively in case of a network error
            fetch(reqObj.url,reqObj).then(function (response) {
                return _parseResponse(response,reqObj);
            }).catch(function (error) {
                _log('Unable to fetch due to a network error: ' + error,logTypes.ERROR, '_send');
                return reqObj.error(error);
            });
        }

        /**
         * Parse response, check if content type is json, then first parse as text to avoid an exception due to an empty json response from server
         * @param response
         * @returns parsed json
         */

        function _parseResponse(response,reqObj) {
            var additionalResponseData = response;
            return response.json().then(function (data) {
                var resp = {
                    body: data,
                    responseCode: additionalResponseData.status,
                    headers: additionalResponseData.headers,
                    HTTPStatus: additionalResponseData.statusText
                };
                _removeFromPending(reqObj);
                if (additionalResponseData.status >= 400) {
                    _log('Response error: ',logTypes.ERROR, '_parseResponse');
                    return reqObj.error(resp);
                }
                else {
                    _log('Response Success: ',logTypes.INFO, '_parseResponse');
                    return reqObj.success(resp);
                }
            }).catch(function(error){
                _log('Unable to parse response: ' + error,logTypes.ERROR, '_parseResponse');
                var resp = {
                    body: {},
                    responseCode: additionalResponseData.status,
                    headers: additionalResponseData.headers,
                    HTTPStatus: additionalResponseData.statusText
                };
                _removeFromPending(reqObj);
              if (additionalResponseData.status >= 400) {
                _log('Response error: ',logTypes.ERROR, '_parseResponse');
                return reqObj.error(resp);
              }
              else {
                _log('Response Success: ',logTypes.INFO, '_parseResponse');
                return reqObj.success(resp);
              }
            });
        }

        /**
         * Build URL query as GET
         * @param url
         * @param data
         * @returns {*}
         */
        function _setUrlQuery(url, data) {
            var dataString;
            dataString = _convertDataToQueryParams(data);
            if (dataString) {
                url += url.indexOf("?") < 0 ? "?" : "&";
                url += dataString;
            }
            return url;
        }

        /**
         * Adds to the list of requests we sent
         * and adds flags for when we started this request to make sure
         * we can time it out properly
         * @param reqObj
         */
        function _addToPendingRequests(reqObj) {
            reqObj.launchTime = new Date();
            pendingRequests.push(reqObj);
            _incrementCalls();
        }

        /**
         * Adds a request to the queue waiting for calls
         * And checks if it can be sent
         * @param reqObj
         */
        function _addToBuffer(reqObj) {
            buffer.push(reqObj);
            _checkBuffer();
        }

        /**
         * Checks for timeout errors
         * on pending requests
         */
        function _checkErrors() {
            if (errorTimeoutId) {
                clearTimeout(errorTimeoutId);
                errorTimeoutId = null;
            }

            var now = new Date();
            var errors = [];
            for (var i = 0; i < pendingRequests.length; i++) {
                var req = pendingRequests[i];
                var timeElapsed = now.valueOf() - req.launchTime.valueOf();
                if (timeElapsed > req.timeout) {
                    _handleError(req, true);
                    errors.push(req);
                }
            }
            for (var j = 0; j < errors.length; j++) {
                _removeFromPending(errors[j]);
                errors[j] = null;
            }

            if (buffer.length > 0 || pendingRequests.length > 0) {
                errorTimeoutId = setTimeout(_checkErrors, 1000);
            }
        }

        /**
         * Generic function for all error callbacks
         * @param reqObj - the original request
         * @param xhr - the XHR of this request
         * @param abortCall - whether this is a timeout
         * @param res - response data for this request if it exists
         */
        function _handleError(reqObj, abortCall, res) {
            _incrementErrors();
            if (reqObj.launchTime) {
                _addToStats(reqObj.launchTime.getTime(), reqObj.url, reqObj.method, res && res.responseCode || 408);
            }
            if (!abortCall) {//In case we're checking for errors, so we don't change the pending request array when iterating through it
                _removeFromPending(reqObj);
            }
            _cleanUpPropertiesFromReq(reqObj);

            if (reqObj.retries > 0 && !res) {
                reqObj.retries = reqObj.retries - 1;
                _addToBuffer(reqObj);
            } else {
                _runCallback(reqObj.error, res || badRequestObj, reqObj.context);
            }
        }

        /**
         * Takes the data parameter and converts it to a query string
         * @param data
         * @return {String}
         */
        function _convertDataToQueryParams(data) {
            var queryString = "";
            if (typeof data === 'string') {
                queryString += data;
            } else {
                var first = true;
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        var value;
                        if (typeof data[key] == 'object') {
                            value = _stringify(data[key]);
                        } else if (typeof data[key] !== 'function') {
                            value = data[key];
                        }
                        if (typeof value !== 'undefined') {
                            if (!first) {
                                queryString += "&";
                            }
                            queryString += encodeURIComponent(key) + "=" + encodeURIComponent(value);
                            first = false;
                        }
                    }
                }
            }
            return queryString;
        }

        /**
         * Deletes any properties we set on the original request
         * Cleanup
         * @param reqObj
         */
        function _cleanUpPropertiesFromReq(reqObj) {
            var properties = ["xhr"];
            for (var i = 0; i < properties.length; i++) {
                reqObj[properties[i]] = null;
                delete reqObj[properties[i]];
            }
        }

        /**
         * Stringifies the data we're going
         * to _send on the request
         * @param data
         * @return {*}
         */
        function _stringifyData(data) {
            if (typeof data === 'object') {
                return _stringify(data);
            } else if (typeof data === 'string') {
                return data;
            } else {
                return '';
            }
        }

        /**
         * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
         * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
         * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
         * The function accepts a value and and uses the native JSON.stringify
         * Can throw an exception (same as JSON.stringify).
         */
        function _stringify(value) {
            var stringified;
            if (typeof Array.prototype.toJSON === 'function') {
                var toJSONPrototype = Array.prototype.toJSON;
                delete Array.prototype.toJSON;
                try {
                    stringified = JSON.stringify(value);
                } catch (e) {
                    Array.prototype.toJSON = toJSONPrototype;
                    throw e;
                }
                Array.prototype.toJSON = toJSONPrototype;
            } else {
                stringified = JSON.stringify(value);
            }
            return stringified;
        }

        /**
         * Checks if we have pending requests in
         * our buffer and sends them
         * @return {Boolean}
         */
        function _checkBuffer() {
            while (pendingRequests.length < 6 && buffer.length > 0) {
                _send(buffer.shift());
            }
        }

        /**
         * Runs callback methods in a protected way
         * @param callback
         * @param data
         * @param context
         */
        function _runCallback(callback, data, context) {
            if (callback && typeof callback == 'function') {
                try {
                    callback.call(context, data);
                } catch (e) {
                    _log(e.message, "error");
                }
            }
        }

        /**
         * Writes a _log
         * @param msg
         * @param type
         * @return {*}
         */
        function _log(msg, type) {
            if (window.lpTag && lpTag.log) {
                lpTag.log(msg, type, transportType);
            }
        }

        /**
         * Increment the internal error counter
         */
        function _incrementErrors() {
            errorCount = errorCount + 1;
        }

        /**
         * Increment the internal call counter and
         * pending requests counter
         */
        function _incrementCalls() {
            callCount = callCount + 1;
        }

        /**
         * Removes the request from our pending list
         * @param reqObj
         */
        function _removeFromPending(reqObj) {
            for (var i = 0; i < pendingRequests.length; i++) {
                if (pendingRequests[i] === reqObj) {
                    pendingRequests.splice(i, 1);
                    break;
                }
            }
        }

        /**
         * Adding the time spent on the request
         * @param startTime
         * @param url
         * @param method
         * @param statusCode
         * @private
         */
        function _addToStats(startTime, url, method, statusCode) {
            var requestDuration, now;
            if (startTime) {
                now = new Date().getTime();
                requestDuration = (now - startTime);
                requestStats.push({
                    rd: requestDuration,
                    ts: startTime,
                    url: url,
                    method: method,
                    statusCode: statusCode
                });

                if (requestStats.length >= defaults.metricsCount) {
                    _publishMetrics();
                }
            }
        }

        /**
         * Publishes stats to lpAjax to decide if we want to report this
         */
        function _publishMetrics() {
            var res;
            if (taglets && taglets.lpAjax.publishMetrics && requestStats.length > 0) {
                lpAjax = taglets.lpAjax;
                res = {
                    tags: [
                        {transport: transportType}
                    ],
                    metrics: requestStats
                };
                lpAjax.publishMetrics(res);
                requestStats.length = 0;
            }
            _setMetricsTimeout();
        }

        /**
         * Clears any previous timeout to set this data and sets up
         * the next time this should happen
         */
        function _setMetricsTimeout() {
            if (metricsTOId) {
                clearTimeout(metricsTOId);
            }
            metricsTOId = setTimeout(_publishMetrics, defaults.metricsTimeout);
        }

        //Exposed methods
        var publicAPI = {
            init: init,
            name: transportType,
            v: version,
            configure: configure,
            issueCall: issueCall,
            isValidRequest: isValidRequest,
            inspect: inspect
        };

        init();
        return publicAPI;
    })(window);



//////////////////
// WEBPACK FOOTER
// ./node_modules/lp-transporter/src/transports/fetch.js
// module id = 410
// module chunks = 0